export default __webpack_public_path__ + "static/concept-work-e80e6b963d78893f6e65a851c51ac838.jpg";